import { render, staticRenderFns } from "./Methodical.vue?vue&type=template&id=081f3854&scoped=true"
import script from "./Methodical.vue?vue&type=script&lang=js"
export * from "./Methodical.vue?vue&type=script&lang=js"
import style0 from "./Methodical.vue?vue&type=style&index=0&id=081f3854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081f3854",
  null
  
)

export default component.exports